const BRAND_LOGO_OVERRIDES: Record<string, string> = {
  // Reuse the existing local logo files; the originals are left untouched.
  gwm: "/logos/great-wall-logo.png",
  mercedes: "/logos/mercedes-benz-logo.png",
  "santana-motors": "/logos/santana-logo.png",
  // New logos for brands that did not have an asset yet.
  "changan-deepal": "/logos/changan-deepal-logo.svg",
  lepas: "/logos/lepas-logo.svg",
  microlino: "/logos/microlino-logo.png",
  xiaomi: "/logos/xiaomi-logo.svg",
};

export const getBrandLogo = (brandId: string): string =>
  BRAND_LOGO_OVERRIDES[brandId] ?? `/logos/${brandId}-logo.png`;
